module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('v-header', {
    on: {
      "searchInfo": _vm.searchInfo,
      "getWordCount": _vm.getWordCount
    }
  }), _vm._v(" "), _c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    ref: "blog",
    attrs: {
      "articleList": _vm.articleListCopy,
      "articleCount": _vm.articleCount,
      "wordCount": _vm.wordCount,
      "userIpCount": _vm.userIpCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "userInfo": _vm.userInfo,
      "isLoading": _vm.isLoading,
      "categories": _vm.categories,
      "nowCategorie": _vm.nowCategorie,
      "tags": _vm.tags,
      "nowTagName": _vm.nowTagName
    },
    on: {
      "getCategories": _vm.getCategories,
      "getTagArticle": _vm.getTagArticle,
      "getColumnArticle": _vm.getColumnArticle,
      "getArticleList": _vm.getArticleList,
      "getWordCount": _vm.getWordCount,
      "geUserIpCount": _vm.geUserIpCount,
      "showMessage": _vm.showMessage,
      "clearArticleList": _vm.clearArticleList
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    ref: "blog",
    attrs: {
      "articleList": _vm.articleListCopy,
      "articleCount": _vm.articleCount,
      "wordCount": _vm.wordCount,
      "userIpCount": _vm.userIpCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "userInfo": _vm.userInfo,
      "isLoading": _vm.isLoading,
      "categories": _vm.categories,
      "nowCategorie": _vm.nowCategorie,
      "tags": _vm.tags,
      "nowTagName": _vm.nowTagName
    },
    on: {
      "getCategories": _vm.getCategories,
      "getTagArticle": _vm.getTagArticle,
      "getColumnArticle": _vm.getColumnArticle,
      "getArticleList": _vm.getArticleList,
      "getWordCount": _vm.getWordCount,
      "geUserIpCount": _vm.geUserIpCount,
      "showMessage": _vm.showMessage,
      "clearArticleList": _vm.clearArticleList
    }
  }) : _vm._e(), _vm._v(" "), _c('v-Message', {
    attrs: {
      "messageShow": _vm.messageShow,
      "sendMessage": _vm.sendMessage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 265
// module chunks = 1